import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { api } from "../lib/api";

const KEY = "sync-configs";

export interface SyncConfig {
	entityType: string;
	direction: "inbound" | "outbound" | "bidirectional";
	conflictResolution: "sap_wins" | "crm_wins" | "last_write_wins" | "manual_review";
	isEnabled: boolean;
	scheduleCron: string | null;
	createdAt: string;
	updatedAt: string;
}

export function useSyncConfigList() {
	return useQuery({
		queryKey: [KEY, "list"],
		queryFn: () => api.get<SyncConfig[]>("/api/sync/configs"),
	});
}

export function useUpdateSyncConfig() {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: ({ entityType, body }: { entityType: string; body: Partial<SyncConfig> }) =>
			api.patch<SyncConfig>(`/api/sync/configs/${entityType}`, body),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: [KEY, "list"] });
		},
	});
}
